import { render, staticRenderFns } from "./IntegrationsOauth2.vue?vue&type=template&id=6a368c01&scoped=true&"
import script from "./IntegrationsOauth2.vue?vue&type=script&lang=js&"
export * from "./IntegrationsOauth2.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationsOauth2.vue?vue&type=style&index=0&id=6a368c01&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a368c01",
  null
  
)

export default component.exports